import { getUser } from "src/api/User";
import { useStorageStore } from "src/stores/StorageStore";


export const refetchUser = async () => {
  const data = await getUser();
  useStorageStore.getState().setItem('user', data);
  
  return data;
};
